module.exports = __webpack_public_path__ + "img/gl.41271612.svg";